// PID-based Support program overrides
// Add PIDs here to display as "Support" instead of their default program type
export const SUPPORT_PROGRAM_PIDS = [
  "Verzenio Ongoing Support",
  "Austedo Teva Total Support",
  "Austedo Support Program - Teva Neuroscience"
];

export const getSupportOverride = (pid, originalValue) => {
  if (SUPPORT_PROGRAM_PIDS.includes(pid)) {
    return "Support";
  }
  return originalValue;
};
